define('components/decorators/clearbutton',[
    'jquery',
    'components/util/clearbutton',
], function($, clearButtonUtil) {

    $.extend(companyInfo.decorators, {

        'clearbutton': function() {
            var form = $(this);
            clearButtonUtil.setClearInputFieldsIcons(form);
        }

    });

});

